const config = {
    maps: {
        dust2: {
            title: 'Dust2',
            chTitle: '炙热沙城Ⅱ',
            imgSrc: 'https://img.lkval.com/static/assets/cs2/map/dust2.jpeg',
            radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/dust2Radar.webp',
        },
        inferno: {
            title: 'Inferno',
            chTitle: '炼狱小镇',
            imgSrc: 'https://img.lkval.com/static/assets/cs2/map/inferno.jpeg',
            radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/infernoRadar.webp',
        },
        mirage: {
            title: 'Mirage',
            chTitle: '荒漠迷城',
            imgSrc: 'https://img.lkval.com/static/assets/cs2/map/mirage.jpeg',
            radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/mirageRadar.webp',
        },
        ancient: {
            title: 'Ancient',
            chTitle: '远古遗迹',
            imgSrc: 'https://img.lkval.com/static/assets/cs2/map/ancient.jpeg',
            radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/ancientRadar.webp',
        },
        anubis: {
            title: 'Anubis',
            chTitle: '阿努比斯',
            imgSrc: 'https://img.lkval.com/static/assets/cs2/map/anubis.jpeg',
            radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/anubisRadar.webp',
        },
        nuke: {
            title: 'Nuke',
            chTitle: '核子危机',
            imgSrc: 'https://img.lkval.com/static/assets/cs2/map/nuke.jpeg',
            radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/nukeRadar.png',
        },
        vertigo: {
            title: 'Vertigo',
            chTitle: '殒命大厦',
            imgSrc: 'https://img.lkval.com/static/assets/cs2/map/vertigo.jpeg',
            radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/vertigoRadar.webp',
        },
        overpass: {
            title: 'Overpass',
            chTitle: '死亡游乐园',
            imgSrc: 'https://img.lkval.com/static/assets/cs2/map/overpass.jpg',
            radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/overpassRadar.webp',
        },
        train: {
            title: 'Train',
            chTitle: '列车停放站',
            imgSrc: 'https://img.lkval.com/static/assets/cs2/map/train.jpg',
            radarImgSrc: 'https://img.lkval.com/static/assets/cs2/map/trainRadar.webp',
        }
    },
    side: {
        1: {
            title: 'T',
            imgSrc: 'https://img.lkval.com/static/assets/cs2/side/side_t.png',
        },
        2: {
            title: 'CT',
            imgSrc: 'https://img.lkval.com/static/assets/cs2/side/side_ct.png',
        },
        0: {
            title: 'Both',
            imgSrc: 'https://img.lkval.com/static/assets/cs2/side/side_both.png',
        }
    },
    ability: {
        1: {
            imgSrc: 'https://img.lkval.com/static/assets/cs2/ability/Smoke.png'
        },
        2: {
            imgSrc: 'https://img.lkval.com/static/assets/cs2/ability/Molly.png'
        },
        3: {
            imgSrc: 'https://img.lkval.com/static/assets/cs2/ability/Hegrenade.png'
        },
        4: {
            imgSrc: 'https://img.lkval.com/static/assets/cs2/ability/Flashbang.png'
        }
    },
    agent: {
        imgSrc: 'https://img.lkval.com/static/assets/cs2/startPoint.png'
    },
    leaflet: {
        addLineup: {
            point: {
                radius: 10,
                startPointFillColor: '#00FF00',
                endPointFillColor: '#FFFF00',
            },
        },
        showLineup: {
            agentImgSize: 70,
            togetherDistance: 14,
            togetherLineup: {
                countCircle: {
                    radius: 18,
                    circleColor: '#FFFFFF',
                },
            },
            abilityImgSize: 60,
            endCircleMouseOver: {
                radius: 40,
                color: '#ffffff',
                weight: 2,
            },
            endCircle: {
                radius: 35,
                fillColor: '#2a2c31',
                fillOpacity: 1,
                weight: 0,
            },
            agentCircle: {
                radius: 30,
                weight: 1,
                fillColor: '#000000',
                fillOpacity: 0.5,
                color: '#ffcc00',
            },
            agentRectangle: {
                sideLength: 40,
                color: "#00FF00",
                weight: 1,
                fillOpacity: 0.2,
            },
            agentRectangleMouseOver: {
                sideLength: 40,
                color: "#00FF00",
                weight: 1,
                fillOpacity: 1,
            },
            agentCircleMouseOver: {
                radius: 40,
                weight: 1,
                fillColor: '#ffcc00',
                fillOpacity: 1,
                color: '#ffcc00',
            },
            startEndLine: {
                color: '#ffffff',
                weight: 1,
            },
            startEndLineMouseOver: {
                color: '#ffcc00',
                weight: 2,
            },
        }
    }
}
export {config}